import { createContext } from 'react';

export const MediaSizeContext = createContext({ width: 1, height: 1 });
